import { defineStore } from 'pinia'
import {
  abTestGlobalKey,
  ABTestOutput,
  ABTestInputCondition,
  ABTestActiveCampaignV2,
  ABTestUserActualCondition,
} from './abtestV2'
import { isOnServer } from '@/utils/ssr'
import { activeCampaigns } from './campaigns'

const defaultInput: ABTestInputCondition = {
  code: '',
  exprId: '',
  exprName: '',
  endDate: '',
  startDate: '',
  stopDate: '',
  endIfPurchased: true,
  trafficRate: 0,
}

const defaultOutput: ABTestOutput = {
  variant: '',
  assignedAt: 0,
  inTest: false,
  subExprId: '',
  subExprName: '',
}

const useABTestStoreV2 = defineStore('abtestV2', {
  state: () => ({
    input: defaultInput,
    output: defaultOutput,
    actualCondition: {} as ABTestUserActualCondition,
    isReady: false,
  }),
  getters: {
    code: (state) => state.input?.code,
    variant: (state) => state.output?.variant,
    startDate: (state) => state.input?.startDate,
    endDate: (state) => state.input?.endDate,
    isPurchased: (state) => !!state.actualCondition?.isPurchased,
  },
  actions: {
    setReady(ready: boolean) {
      this.isReady = ready
    },
    syncFromLocalStorage() {
      if (isOnServer) return
      const globalStatus = localStorage.getItem(
        abTestGlobalKey.activeCampaignKey
      )
      if (globalStatus) {
        try {
          const parsed = JSON.parse(globalStatus) as ABTestActiveCampaignV2
          const campaignCode = parsed?.input?.code
          const foundCampaign = activeCampaigns?.find?.((c) => c.code === campaignCode)

          this.input = parsed?.input
          if (foundCampaign?.code) {
            this.input = foundCampaign
          }
          this.output = parsed?.output
          this.actualCondition = parsed?.actualCondition
        } catch (e) {
          console.error('[ABTestV2] Error parsing global active key', e)
        }
      }
    },

    /**
     * Cập nhật metadata của chiến dịch đang hoạt động.
     * Logic: Gộp dữ liệu mới vào state hiện tại của store.
     */
    setCampaign(data: {
      input?: Partial<ABTestInputCondition>
      output?: Partial<ABTestOutput>
      actualCondition?: Partial<ABTestUserActualCondition>
    }) {
      if (isOnServer) return

      if (data.input)
        this.input = { ...this.input, ...data.input } as ABTestInputCondition
      if (data.output)
        this.output = { ...this.output, ...data.output } as ABTestOutput
      if (data.actualCondition)
        this.actualCondition = {
          ...this.actualCondition,
          ...data.actualCondition,
        } as ABTestUserActualCondition

      this.saveToLocalStorage()
    },

    clearCampaign() {
      this.input = defaultInput
      this.output = defaultOutput
      this.actualCondition = {}
      if (typeof window !== 'undefined') {
        localStorage.removeItem(abTestGlobalKey.activeCampaignKey)
      }
    },

    saveToLocalStorage() {
      if (isOnServer) return
      const data: ABTestActiveCampaignV2 = {
        input: {
          code: this.input?.code || '',
        } as ABTestInputCondition,
        output: this.output as ABTestOutput,
        actualCondition: {
          isPurchased: !!this.actualCondition?.isPurchased,
        },
      }
      localStorage.setItem(
        abTestGlobalKey.activeCampaignKey,
        JSON.stringify(data)
      )
    },
  },
})

export default useABTestStoreV2
